<template>

  <div>

    <v-card>

      <v-card-title class="pb-6">

        Listados de Alianzas

        <v-spacer />

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          style="max-width: 400px"
        />

        <v-spacer />

      </v-card-title>


      <v-data-table
        :headers="headers"
        :items="configs"
        :search="search"
        :custom-filter="customFilter"
      >

        <!-- Compañía -->
        <template
          v-slot:item.NombreCompania="{ item }"
        >

          [
          {{ item.IdCompania }}
          ]
          {{ item.NombreCompania }}

        </template>

        <template
          v-slot:item.acciones="{ item }"
        >
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                title="Acciones"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="openAudit(item, 'report')">
                <v-list-item-icon>
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Reporte redenciones
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="openAudit(item, 'logs')">
                <v-list-item-icon>
                  <v-icon>mdi-file-code-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Descargar logs
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>


        <!-- Alianza -->
        <template
          v-slot:item.NombreAlianza="{ item }"
        >

          {{ item.NombreAlianza }}

        </template>


        <!-- Código -->
        <template
          v-slot:item.CodigoAlianza="{ item }"
        >

          {{ item.CodigoAlianza }}

        </template>


        <!-- CodeStores -->
        <template
          v-slot:item.stores="{ item }"
        >

          <v-btn
            icon
            color="primary"
            title="Terminales"
            @click="openStores(item)"
          >

            <v-icon>
              mdi-store
            </v-icon>

          </v-btn>

        </template>


        <!-- Estado -->
        <template
          v-slot:item.Active="{ item }"
        >

          <div class="d-flex justify-center">

            <v-switch
              v-model="item.Active"
              inset
              @change="changeStatus(item)"
            />

          </div>

        </template>


        <!-- Editar -->
        <template
          v-slot:item.editar="{ item }"
        >

          <v-btn
            icon
            color="warning"
            title="Editar"
            @click="editar(item)"
          >

            <v-icon>
              mdi-pencil
            </v-icon>

          </v-btn>

        </template>

      </v-data-table>

    </v-card>

    <download-audit-dialog
      v-model="showDownloadDialog"
      :company="selectedAlianza"
      :type="downloadType"
      @download="downloadAudit"
    />

  </div>
</template>


<script>

  import DownloadAuditDialog from '../../LoyaltyConfig/components/DownloadAuditDialog.vue'

  export default {

    components: {
      DownloadAuditDialog,
    },

    data () {

      return {

        search: '',

        showDownloadDialog: false,

        selectedAlianza: null,

        downloadType: null,


        headers: [

          {
            text: 'Compañía',
            value: 'NombreCompania',
          },

          {
            text: 'Alianza',
            value: 'NombreAlianza',
          },

          {
            text: 'Código',
            value: 'CodigoAlianza',
          },

          {
            text: 'Establecimientos',
            value: 'stores',
            sortable: false,
            align: 'center',
          },

          {
            text: 'Editar',
            value: 'editar',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            sortable: false,
            align: 'center',
          },
        ],

      }

    },


    computed: {

      configs () {

        const configs =
          this.$store.state
            .alianzas
            .configs || []


        const clients =
          (
            this.$store.state
              .invoice
              .listClients
              .Mensaje || []
          )


        return configs.map(config => {

          const company =
            clients.find(
              item =>
                item.IdCompania ===
                config.IdCompania,
            )


          return {

            ...config,

            NombreCompania:
              config.NombreCompania ||
              (
                company
                  ? company.NombreCompania
                  : ''
              ),

          }

        })

      },

    },


    created () {

      this.load()

      this.loadClients()

    },


    methods: {

      load () {

        return this.$store.dispatch(
          'alianzas/getConfigs',
        )

      },


      loadClients () {

        return this.$store.dispatch(
          'invoice/getListClients',
        )

      },


      openStores (item) {

        this.$emit(
          'stores',
          item,
        )

      },

      openAudit (item, type) {
        this.selectedAlianza = item
        this.downloadType = type
        this.showDownloadDialog = true
      },

      downloadAudit (data) {
        const action = data.type === 'logs'
          ? 'alianzas/downloadAuditLogs'
          : 'alianzas/downloadAuditReport'

        this.$store.dispatch(action, data)
      },


      editar (item) {

        this.$emit(
          'editar',
          item,
        )

      },


      async changeStatus (item) {

        await this.$store.dispatch(
          'alianzas/updateConfig',
          {
            id: item.Id,

            IdCompania:
            item.IdCompania,

            NombreAlianza:
            item.NombreAlianza,

            CodigoAlianza:
            item.CodigoAlianza,

            DataIntegration:
            item.DataIntegration,

            Active:
            item.Active,
          },
        )

        this.load()

      },


      customFilter (
        value,
        search,
        item,
      ) {

        if (!search) {

          return true

        }


        const text =
          search
            .toString()
            .toLowerCase()


        return (

          String(
            item.IdCompania || '',
          )
            .toLowerCase()
            .includes(text)

          ||

          String(
            item.NombreCompania || '',
          )
            .toLowerCase()
            .includes(text)

          ||

          String(
            item.NombreAlianza || '',
          )
            .toLowerCase()
            .includes(text)

          ||

          String(
            item.CodigoAlianza || '',
          )
            .toLowerCase()
            .includes(text)

        )

      },

    },

  }

</script>
